@if (item) {
  <div #cardWrapper fxFlex [ngClass]="cardClass">
    @if (!editMode) {
      <info-card-view [item]="item" (itemChange)="onItemChange($event)" [compact]="compact" [headerTemplate]="headerTemplate" [detailTemplate]="detailTemplate" [editable]="editable" [expand]="expand" [expandable]="expandable" [canDelete]="canDelete" [outlined]="outlined" [refreshLayout]="refreshLayoutObservable" (edit)="onEdit()" (refreshCollection)="onRefresh()" [hasClientActionDefined]="hasClientActionFunction" (clientAction)="doClientAction($event)">
      </info-card-view>
    }
    @if (editMode) {
      <info-card-edit fxFlex="100" [infoCard]="item" [outlined]="outlined" [returnCriteria]="criteria" [saveable]="saveable" (save)="onSave($event)" (cancel)="onCancel()">
      </info-card-edit>
    }
  </div>
}
